import { Grid } from "@root/shared/components/Grid";
import { DetailWorkCassette } from "@userFrontend/features/publication/components/DetailWorkCassette";
import { type ComponentProps, type FC } from "react";
import * as styles from "./styles.css";

type Props = {
  headingText: string;
  subHeadingText?: string;
  cassettes: ComponentProps<typeof DetailWorkCassette>[];
};

export const Presentation: FC<Props> = ({ headingText, subHeadingText, cassettes }) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {subHeadingText && <p className={styles.subHeading}>{subHeadingText}</p>}
        <h2 className={styles.heading}>{headingText}</h2>
        <Grid columns={{ base: 1, medium: 2 }} gapX={24} gapY={24}>
          {cassettes.map((cassette) => (
            <DetailWorkCassette key={cassette.buttonProps.workCode} {...cassette} />
          ))}
        </Grid>
      </div>
    </div>
  );
};
